// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchIcon-module--icon--2-1eo"};